import {
    NOTIFY_ERROR,
    DISMISS_MESSAGE,
    NOTIFY_COMPLETE_CHECKOUT_ERROR
} from '../../GlobalStateContainer'

import {
    ERROR_USER_ALERT,
    UNKNOWN_USER_ALERT
} from './userAlertTypes'


import {
    addToList,
    replaceInListById,
    removeFromList
} from '../../../util/listUtility'

const mapActionTypeToUserAlertType = (actionType) => {
    switch (actionType) {
        case NOTIFY_ERROR:
        case NOTIFY_COMPLETE_CHECKOUT_ERROR:
            return ERROR_USER_ALERT;
        default:
            return UNKNOWN_USER_ALERT;
    }
}

export function messages(state = [], action) {
    switch (action.type) {
        case NOTIFY_ERROR:
            return addToListAndReplaceIfExists(
                state,
                {
                    type: mapActionTypeToUserAlertType(action.type),
                    text: action.message,
                    id: action.messageId
                });
        case NOTIFY_COMPLETE_CHECKOUT_ERROR:
            let text = "We're sorry, but are unable to complete checkout. Please reload the page and try again, or contact customer service.";
            if (!!action.diagnosticMessage) {
                let parsedDM = JSON.parse(action.diagnosticMessage);
                if (!!parsedDM.ShowMessageToUser) {
                    text = action.message;
                }
            }
            return addToListAndReplaceIfExists(
                state,
                {
                    type: mapActionTypeToUserAlertType(action.type),
                    text: text,
                    id: action.messageId
                });
        case DISMISS_MESSAGE:
            return replaceInListById(
                state,
                Object.assign({}, state.filter(m => m.Id === action.messageId)[0], { dismissed: true }))
        default:
            return state;
    }
}

const addToListAndReplaceIfExists = (existingMessages, newMessage) => {
    let updatedMessages = existingMessages || [];
    for (var i = 0; i < existingMessages.length; i++) {
        if (newMessage.text === existingMessages[i].text) {
            updatedMessages = removeFromList(existingMessages, existingMessages[i]);
            break;
        }
    }
    return addToList(updatedMessages, newMessage);
}